const DATA_TEST_IDS = {
  profileEditProfileEdit: 'profile__profile-edit_profile-edit',
} as const;

export default DATA_TEST_IDS;
